<template>
    <div class="timeRangeSelect">
        <ul>
            <li :key="item.start" v-for="(item, index) in list" @click="onChangeTimeRange(index)" :class="{ on: index === selectIndex }">
                 <span class="day">{{ getDayTimeFormat(item.start * 1000) }}</span>
                 <span class="time">{{ getTimeFormat(item.start * 1000) }}</span>
                 <span class="state">{{ stateText[getTimeState(item)] }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
import { dateFormatter } from '@/utils/timeCalculate'
export default {
    name: 'seckillTimeRangeSelect',
    props: {
        list: {
            type: Array,
            default: () => {
                return []
            }
        },
        now_time: {
            type: Number,
            default: 0
        }
    },
    data () {
        return {
            selectIndex: 0, // 当前选择的索引
            nowTime: 0, // 当前时间
            stateText: ['未开始', '抢购中', '已结束'], // 当前选中的状态
        }
    },
    watch: {
        now_time: {
            handler (newValue, oldValue) {
                this.nowTime = newValue
            }
        },
    },
    created () {

    },
    activated () {

    },
    mounted () {
    },
    methods: {
        /**
         * 获取时间状态
         */
        getTimeState (timeInfo) {
            const remainTime = timeInfo.start - this.nowTime
            if (remainTime <= 0) {
                this.remainTime = timeInfo.end - this.nowTime
                if (this.remainTime < 0) {
                    return 2
                } else {
                    return 1
                }
            } else if (remainTime > 0) {
                return 0
            }
        },
        /**
         * 格式化时间
         */
        getTimeFormat (time) {
            return dateFormatter('HH:mm', time)
        },
        /**
         * 格式化天数时间
         */
        getDayTimeFormat (time) {
            const t1 = dateFormatter('MM-DD', this.nowTime * 1000)
            const t2 = dateFormatter('MM-DD', time)
            if (t1 !== t2) {
                return t2
            } else {
                return ''
            }
        },
        /**
         * 时间范围选择改变
         */
        onChangeTimeRange (index) {
            const state = this.getTimeState(this.list[index])
            if (this.selectIndex !== index) {
                this.selectIndex = index
                this.$emit('callBack', {
                    ...this.list[index],
                    state
                })
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '../../../../assets/stylus/variables'
.timeRangeSelect
    padding 16px 30px 36px 30px
    height auto
    ul
        white-space nowrap
        overflow-x scroll
        overflow-y hidden
        li
            display inline-block
            margin-right 50px
            .time
                font-size 34px
                color #333333
                margin-bottom 15px
                font-weight bolder
                display block
            .state
                display block
                height 30px
                line-height 30px
                font-size 22px
                color #666666
                text-align center
            .day
                font-size 24px
                display block
                text-align center
                height 34px
                color #555
        li.on
            .time
                color #fc2d2d
            .state
                background #fc2d2d
                color #fff
                border-radius 14px
</style>
